module.exports = __webpack_public_path__ + "static/austin-8afc26a1b0c490220bae737f7d989dc5.jpg";